<template>
  <div class="search-filters-standalone">
    <div
      class="search-filters__desktop-results-label"
      v-text="label"
    />
    <search-filters-select
      v-for="(filter, i) in filtersList.filters"
      :key="i"
      :close-on-outside-click="false"
      :collapse-icon-alt="collapseIconAlt"
      :event-category="eventCategory"
      :expand-icon-alt="expandIconAlt"
      :filter="filter"
      filter-label=""
      :is-search-page="isSearchPage"
      :initial-display="i === 0"
      :show-more="showMore"
      @selected-option="selectOption"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SearchFiltersSelect from '@Feature/SearchFilters/code/Scripts/components/SearchFiltersSelect/SearchFiltersSelect.vue';

export default {
  components: {
    SearchFiltersSelect,
  },

  props: {
    collapseIconAlt: {
      default: 'Collapse',
      type: String,
    },
    eventCategory: {
      default: 'search',
      type: String,
    },
    expandIconAlt: {
      default: 'Expand',
      required: false,
      type: String,
    },
    initialFilters: {
      required: true,
      type: Object,
    },
    isSearchPage: {
      default: false,
      required: false,
      type: Boolean,
    },
    label: {
      default: 'Filter',
      type: String,
    },
    showMore: {
      default: () => ({
        label: 'Show ${a} more',
        limit: 10,
      }),
      type: Object,
    },
  },

  data: () => ({
    filtersList: [],
  }),

  computed: {
    ...mapGetters('searchFiltersStore', ['articlesFilters']),
  },

  watch: {
    articlesFilters(filters) {
      this.filtersList = filters;
    },
  },

  mounted() {
    this.filtersList = this.initialFilters;
    this.setArticlesFilters(this.filtersList);
  },

  methods: {
    ...mapActions('searchFiltersStore', [
      'selectArticlesFiltersOption',
      'setArticlesFilters',
      'unselectArticlesFiltersOption',
    ]),

    selectOption(option) {
      const { checked, filterId, selectedOptionId } = option;

      if (checked) {
        this.selectArticlesFiltersOption({ filterId, selectedOptionId });
        return;
      }

      this.unselectArticlesFiltersOption({ filterId, selectedOptionId });
    },
  },
};
</script>
